module.exports = __webpack_public_path__ + "img/1 (128).f90ab706.png";